/**
 * expand / collapse long passages of text
 */
(function () {

	"use strict";

	// expand/collapse the clicked element
	// when click "Expand+" link, expand the text
	// when click "Collapse+" link, collapse the text
	function handleClick (event) {

		const button = event.currentTarget;
		const element = button.parentNode;
		const isExpanded = element.classList.contains("expandedHeight");
		if (isExpanded) {

			element.classList.add("collapsedHeight");
			element.classList.remove("expandedHeight");
			setTimeout(() => button.innerText = "Expand +", 200);

		} else {

			element.classList.remove("collapsedHeight");
			element.classList.add("expandedHeight");
			setTimeout(() => button.innerText = "Collapse –", 200);

		}

	}

	const elements = Array.from(document.querySelectorAll(".expandable"));

	elements.forEach(function (element) {
		var offsetHeight = element.getAttribute("data-height");

		if (element.offsetHeight > offsetHeight) {
			// create Expand+, Collapse- button
			let button = document.createElement("button");
			button.innerText = "Expand +";
			button.addEventListener("click", handleClick);
			element.appendChild(button);

			// collapse text
			element.classList.add("collapsedHeight");

		}
	});

}());